import logoShab from '../../../public/images/logo-shab.svg';
import Link from 'next/link';
import Image from 'next/image';
import styles from './LogoContainer.module.scss';
import Box from '@/components/UI/box/Box';
const LogoContainer = () => {
  return <Box className={styles['logo-container']} data-sentry-element="Box" data-sentry-component="LogoContainer" data-sentry-source-file="LogoContainer.tsx">
      <Link href={'/'} className={styles['logo']} passHref data-sentry-element="Link" data-sentry-source-file="LogoContainer.tsx">
        <Image src={logoShab} alt="سایت شب" width={96} data-sentry-element="Image" data-sentry-source-file="LogoContainer.tsx" />
      </Link>
    </Box>;
};
export default LogoContainer;